export default "/images/vendor/flag-icon-css/flags/4x3/hr.svg?00a76e1b588a62b0fad98dd62bd1283b";